function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "nu-a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M0 0h496v372H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nu-a)",
  transform: "scale(1.2902)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 0h499.6v248.1H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c8102e",
  d: "M0 0v18.6L119.2 80l44.9 1.3L0 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "m51 0 144.6 75.5V0H51z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c8102e",
  d: "M214.9 0v96.4H0v55h215v96.4h66v-96.4h215v-55H281V0h-66z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M300.2 0v71.1L441.6.6 300.2 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c8102e",
  d: "m304.7 78.9 39.8-.3L498.9.6l-41 .6L304.8 79z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 167.5v52.8L99.2 168 0 167.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c8102e",
  d: "m381.9 169.7-41.4-.3 155.8 77.5-1-17.7-113.5-59.5zM38.7 248.3l146.1-76.8-38.3.3L0 248.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "m497.9 21.8-118 58.5 116.4.5v87.1h-99.1l98.2 53.3 1.4 27-52.4-.6-143.6-70.5v71.2H196V177L61.3 248l-60.9.2V496H992V.4L499 0M.6 28 0 79.4l104.4 1.3L.5 28z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fedd00",
  fillRule: "evenodd",
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  d: "M496 0h496.1v496h-496z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 248h523.5v248H0z"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M290.9 125.3a42.8 42.8 0 1 1-85.5 0 42.8 42.8 0 0 1 85.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fedd00",
  d: "m240.2 114.3 8.2-24.6 8.2 24.6h26.7l-21.6 15.2L270 154l-21.6-15.3-21.6 15.2 8.3-24.5-21.6-15.2zm148.5 4 4.1-11.5 4 11.6h13.3l-10.7 7 4.1 11.5-10.7-7-10.7 7 4.1-11.5-10.7-7zM244.1 204l4-11.5 4.1 11.5h13.2l-10.7 7 4.1 11.6-10.7-7.1-10.7 7 4.1-11.4-10.7-7.1zm0-167 4-11.6 4.1 11.5h13.2L254.7 44l4.1 11.5-10.7-7-10.7 7 4.1-11.5-10.7-7zM98.9 118.2l4.1-11.5 4 11.5h13.3l-10.7 7.1 4.1 11.5-10.7-7-10.7 7 4.1-11.5-10.7-7z"
})));

var SvgNu = function SvgNu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-nu",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nu.ea0da15f.svg";
export { ForwardRef as ReactComponent };